import React from "react"
import { ThemeProvider } from "styled-components"

import useVideoTracking from "hooks/useVideoTracking"
import componentThemeExtension from "utils/componentThemeExtension"

import { VideoContainer } from "./styles"

const Video = ({ element }) => {
  const { videoId, videoSignature, playerSignature, autoplay } = element

  const { trackVideoProgress } = useVideoTracking()
  const progressTracker = trackVideoProgress(videoId, `article-video-${videoId}`)

  return (
    <ThemeProvider theme={componentThemeExtension(null)}>
      <VideoContainer
        videoId={videoId}
        videoSignature={videoSignature}
        playerId={playerSignature}
        autoPlay={Boolean(autoplay)}
        onPercentViewed={progressTracker}
      />
    </ThemeProvider>
  )
}

export default Video
